<template>
  <div class="min-h-screen">
    <div
      class="bg-static-default-low z-10 flex h-52 items-center justify-start py-20 md:sticky md:top-0 md:h-60"
    >
      <div class="h-12 md:h-16">
        <RevIllustration
          :alt="COMPANY_NAME"
          :height="24"
          src="/img/minimal-header/logo.svg"
          :width="180"
        />
      </div>
    </div>
    <TheFileLibrary />

    <slot />
  </div>

  <TheFeedbackPrompt />
  <div id="toast-wrapper" class="fixed z-50">
    <TheToast to="#toast-wrapper" />
  </div>
  <CookiesModal />
</template>

<script setup lang="ts">
import { useHead, useRuntimeConfig } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'
import { RevIllustration } from '@ds/components/Illustration'

import { TABLEAU_SRC, TABLEAU_URL } from '~/constants/tableau'

import translations from './default.translations'

const runtimeConfig = useRuntimeConfig()
const { COMPANY_NAME } = runtimeConfig.public

const lang = toRfc4646Locale(useI18nLocale())
const i18n = useI18n()
// /**
//  * Because this script write on the document, it is not possible to have it only on a specific page.
//  * If so, when navigating to this page on the browser side, we'll get the error.
//  * ``Failed to execute 'write' on 'Document': It isn't possible to write into a document from an asynchronously-loaded external script unless it is explicitly opened.``
//  * To avoid this, we load the script in the backoffice layout, and that way we'll always have it available.
//  * Note: i'm not a fan at all of this solution, but the only other solution i found was to reload the page
//  * if `window.tableau.Viz` was not present, and it's not so great in term of UX
//  */
useHead({
  title: i18n(translations.pageTitle),
  script: [{ src: TABLEAU_SRC }],
  link: [{ rel: 'dns-prefetch', href: TABLEAU_URL }],
  htmlAttrs: {
    lang,
  },
})
</script>
